import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Label,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import moment from 'moment'
import Shimmer from "react-shimmer-effect";

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear + 3 ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}

const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

class IndexView extends Component {

    createBloc = new CreateBloc();
    queryParams = new URLSearchParams(window.location.search)

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            monthOptions: createMonthOptions(),
            rankOption: [],
            ikuOption: [],
            detail:{},
            period:{},
            Allperiod:[],
            sikap:[],
            total:0,
            average:0,
            skpsikap:0,
            skpAll:0,
            nilai_prestasi:'',
            emptype:'',
            emptypeOption:[],
            satuanWaktuOption: [
                { label: "Bulan", value: 'Bulan' },
                { label: "Triwulan", value: 'Triwulan' },
                { label: "Semester", value: 'Semester' }
            ],
            naskp:0,
            currentmonth : new Date().getMonth() + 1
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    dateParse = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('DD/MM/YYYY')
      }
      return res;
    }

    submitData = async () => {
        // const formData = generateFormData(this.state.dataForm, '') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreateBehavior(this.state.dataForm)
        // console.log(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }
    getEmployeeBirthDetail = (emp) => {
        let res = "";
        if (emp.employee_place_of_birth_city_uuid != null && emp.employee_place_of_birth_city_uuid != '') {
            res = `${emp.employee_place_of_birth_city_name}, ${this.dateParse(emp.employee_date_of_birth)}`;
        } else {
            res = `${emp.employee_place_of_birth_city_text}, ${this.dateParse(emp.employee_date_of_birth)}`;
        }
        return res;
    }
    changeEmptype = (e) => {
        // alert(e.value)
        this.setState({
            emptype : e.value
        })
    }
    setCount = (e) => {
        // alert(e.target.value)
        // alert(this.state.sikap.length)
        let total = 0;
        let lengthsikap =(this.state.emptype.toLowerCase()=='fungsional tertentu')?(this.state.sikap.length-1):(this.state.sikap.length);
        this.state.sikap.forEach((el, i) => {
            let val = document.getElementById(`skp_work_behavior_value_${i}`).value;
            let num = isNaN(val) ? 0 : (val != '' ? val : 0)
            total += parseFloat(num);
        });
        let skpAll = 0
        
        for(let i=0;i<this.state.Allperiod.length;i++){
            skpAll += (this.state.Allperiod[i].skp_period_skp_average!=null)?parseFloat(this.state.Allperiod[i].skp_period_skp_average):0
        }
        let average = (total/this.state.sikap.length)
        // let average = (total/lengthsikap)
        let skpsikap = (average*40/100)+((skpAll!='')?parseFloat((skpAll/this.state.Allperiod.length)*60/100):0)
        let nilai_prestasi = (() => {
            if(skpsikap<50){
                return "Buruk";
            }
            if(skpsikap<60){
                return "Sedang";
            }
            if(skpsikap<75){
                return "Cukup";
            }
            if(skpsikap<90){
                return "Baik";
            }
            if(skpsikap<99){
                return "Sangat Baik";
            }
          })()

        this.setState({
            total : total,
            average : average,
            skpsikap : skpsikap,
            nilai_prestasi : nilai_prestasi,
        })
    }

    componentDidMount() {
        this.setCount()
        this.createBloc.createBehaviorChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:

                    if (result.data.status){
                        this.setState({
                            loading: false,
                            success: true
                        });
                    } else {
                        this.setState({
                            loading: false,
                            message: result.data.message,
                            failed: true
                        });
                    }

                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response_employee = result.data.response
                        this.setState({
                            detail: response_employee,
                            emptype : response_employee.employee_type_name.toLowerCase()
                        })
                        // console.log(this.state.emptype.toLowerCase())
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.createBloc.emptypeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    // console.log(result.data.response.result)
                    this.setState({ 
                        emptypeOption: result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.employee_type_name;
                            newObj["value"] = data.employee_type_name.toLowerCase();
                            
                            return newObj;
                        }), 
                        loadingRank: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });

        this.createBloc.ikuChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        ikuOption: result.data.response.map(function(data) {
                            var newObj = {};
                            newObj["label"] = data.skp_iku_name;
                            newObj["value"] = data.skp_iku_uuid;
                        
                            return newObj;
                          }), 
                        loadingEchelon: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });
        this.createBloc.sikapChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            sikap: response
                        })
                        console.log('this.state.sikap')
                        console.log(this.state.sikap)
                        this.setCount()
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })
        this.createBloc.periodeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            period: response
                        })
                        console.log(response)
                        this.setCount()
                        this.createBloc.fetchPeriodAll({euuid : response.skp_period_employee_uuid,tahun:response.skp_period_year})
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })
        this.createBloc.AllperiodeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        this.setState({
                            Allperiod: response
                        })
                        
                        console.log('ini')
                        console.log(response)
                        // this.setCount()
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })
         console.log('all period')
         console.log(this.state.Allperiod)
        this.createBloc.fetchPeriod({perioduuid : this.queryParams.get('perioduuid')})
        this.createBloc.fetchSikap({euuid : this.queryParams.get('euuid'),perioduuid : this.queryParams.get('perioduuid')})
        this.createBloc.fetchRank()
        this.createBloc.fetchEmployee({uuid: this.queryParams.get('euuid') })
        this.createBloc.fetchIku({uuid: this.queryParams.get('unituuid')})
        this.createBloc.fetchInitialHeader({employee_uuid: this.queryParams.get('euuid') })
        this.createBloc.fetchEmployeeType()
    }

    componentWillUnmount(){
        this.createBloc.periodeChannel.unsubscribe()
        this.createBloc.AllperiodeChannel.unsubscribe()
        this.createBloc.createBehaviorChannel.unsubscribe()
        this.createBloc.initialHeaderChannel.unsubscribe()
        this.createBloc.sikapChannel.unsubscribe()
    }

    render() {
        let skpAll = 0
        let naskp = 0
        for(let i=0;i<this.state.Allperiod.length;i++){
            skpAll += (this.state.Allperiod[i].skp_period_skp_average!=null)?parseFloat(this.state.Allperiod[i].skp_period_skp_average):0
        }
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Penilaian Perilaku </CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <div>
                                        <label>Data Pegawai</label><br />
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            NIP
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            Nama
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                                    : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        {/* <Row className="mb-3">
                                            <label className="col-md-2">
                                            Tempat, Tanggal Lahir
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.getEmployeeBirthDetail(this.state.detail)}</>
                                                    : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row> */}
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            Jabatan
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                    : <Shimmer><div style={{width: 400, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                            Unit Kerja
                                            </label>
                                            <Col md="8">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                    : <Shimmer><div style={{width: 400, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                    <hr /><br />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >   
                                        {/* {
                                            this.state.sikap.map((item, index) => {
                                                return (
                                                    <Row className="mb-3" key={index}>
                                                        <label className="col-md-2">
                                                        {
                                                            this.state.sikap ?
                                                                <>
                                                                    {item.work_behavior_type_name !== "" ? item.work_behavior_type_name : '-'}
                                                                </>
                                                            : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                        }
                                                        </label>
                                                        <Col md="1">
                                                            {
                                                                this.state.sikap ?
                                                                    <>
                                                                        <AvField
                                                                            name={`skp_work_behavior_value[${index}]`}
                                                                            // placeholder={"Masukkan "+item.work_behavior_type_name}
                                                                            type="number"
                                                                            errorMessage={"Masukkan "+item.work_behavior_type_name}
                                                                            className="form-control"
                                                                            validate={{ required: { value: true } }}
                                                                            id={"skp_work_behavior_value_"+index}
                                                                            value={item.skp_work_behavior_value !== "" ? item.skp_work_behavior_value : ''}
                                                                            onChange={(e) => this.setCount(e)}
                                                                        />
                                                                        <AvField
                                                                            name={`skp_work_behavior_type_uuid[${index}]`}
                                                                            type="hidden"
                                                                            id={"skp_work_behavior_type_uuid_"+index}
                                                                            value={item.work_behavior_type_uuid !== "" ? item.work_behavior_type_uuid : ''}
                                                                        />
                                                                    </>
                                                                : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                            }
                                                        </Col>
                                                    </Row>
                                                )
                                            })
                                        }      */}
                                    
                                    

                                        {(this.state.currentmonth!=12)?
                                        <div class="alert alert-warning fade show" role="alert"><b>Perhatian!</b> Penilaian Perilaku Hanya dapat diinputkan pada bulan Desember.</div>
                                        :''}
                                        <hr />
                                        <AvField
                                            name={`skp_work_behavior_period_uuid`}
                                            type="hidden"
                                            id={"skp_work_behavior_period_uuid"}
                                            value={this.queryParams.get('perioduuid')}
                                        />          
                                        <table className="table table-bordered table-striped">
                                        {/* <table className="table table-bordered" style={{borderWidth:"1px",borderColor:"black"}}> */}
                                            <thead style={{backgroundColor:"lavender"}}>
                                                <tr>
                                                    <th colSpan={4}>Unsur yang Dinilai</th>
                                                    <th>Jumlah</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th colSpan={2}>a.Sasaran Kerja Pegawai</th>
                                                    <th>{(skpAll/this.state.Allperiod.length)}</th>
                                                    <th>X &nbsp; 60%</th>
                                                    <th>{naskp =((skpAll/this.state.Allperiod.length)*60/100)}</th>
                                                </tr>
                                                
                                                {
                                                    this.state.sikap.map((item, index) => {
                                                        return (
                                                            <tr>
                                                                {
                                                                    (index == 0) &&
                                                                    <th rowSpan={(this.state.sikap.length+3)} style={{verticalAlign:"middle"}}>b.Perilaku Kerja</th>
                                                                }
                                                                <th>
                                                                {
                                                                    this.state.sikap ?
                                                                        <>
                                                                            {item.work_behavior_type_name !== "" ? item.work_behavior_type_name : '-'}
                                                                        </>
                                                                    : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                                }
                                                                </th>
                                                                <td width="90px">
                                                                {
                                                                        this.state.sikap ?
                                                                            <>{
                                                                                (this.state.period.skp_period_status == 8 && this.state.currentmonth ==12)?
                                                                                <>
                                                                                    <AvField
                                                                                        name={`skp_work_behavior_value[${index}]`}
                                                                                        // placeholder={"Masukkan "+item.work_behavior_type_name}
                                                                                        type="number"
                                                                                        errorMessage={"Masukkan "+item.work_behavior_type_name}
                                                                                        className="form-control"
                                                                                        validate={{ required: { value: true } }}
                                                                                        id={"skp_work_behavior_value_"+index}
                                                                                        value={item.skp_work_behavior_value !== "" ? item.skp_work_behavior_value : ''}
                                                                                        onChange={(e) => this.setCount(e)}
                                                                                        style={{width:"80px"}}
                                                                                    />
                                                                                    <AvField
                                                                                        name={`skp_work_behavior_type_uuid[${index}]`}
                                                                                        type="hidden"
                                                                                        id={"skp_work_behavior_type_uuid_"+index}
                                                                                        value={item.work_behavior_type_uuid !== "" ? item.work_behavior_type_uuid : ''}
                                                                                    />
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <AvField
                                                                                        name={`skp_work_behavior_value[${index}]`}
                                                                                        // placeholder={"Masukkan "+item.work_behavior_type_name}
                                                                                        type="number"
                                                                                        errorMessage={"Masukkan "+item.work_behavior_type_name}
                                                                                        className="form-control"
                                                                                        validate={{ required: { value: true } }}
                                                                                        id={"skp_work_behavior_value_"+index}
                                                                                        value={item.skp_work_behavior_value !== "" ? item.skp_work_behavior_value : ''}
                                                                                        onChange={(e) => this.setCount(e)}
                                                                                        style={{width:"80px"}}
                                                                                        readonly="readonly"
                                                                                    />
                                                                                    <AvField
                                                                                        name={`skp_work_behavior_type_uuid[${index}]`}
                                                                                        type="hidden"
                                                                                        id={"skp_work_behavior_type_uuid_"+index}
                                                                                        value={item.work_behavior_type_uuid !== "" ? item.work_behavior_type_uuid : ''}
                                                                                    />
                                                                                </>
                                                                            }
                                                                            </>
                                                                        : <Shimmer><div style={{width: 300, height: 15}}></div></Shimmer>
                                                                    }
                                                                </td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                <tr>
                                                    <td>Jumlah</td>
                                                    <td>
                                                        <AvField
                                                            name="total"
                                                            // placeholder="Target Biaya..."
                                                            type="number"
                                                            errorMessage="Masukkan Target Biaya"
                                                            className="form-control"
                                                            // validate={{ required: { value: true } }}
                                                            id="total"
                                                            value={this.state.total}
                                                            readonly="readonly"
                                                        />
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>Nilai Rata-rata</td>
                                                    <td>
                                                        <AvField
                                                            name="rata_rata"
                                                            // placeholder="Target Biaya..."
                                                            type="number"
                                                            errorMessage="Masukkan Target Biaya"
                                                            className="form-control"
                                                            // validate={{ required: { value: true } }}
                                                            id="rata_rata"
                                                            value={this.state.average}
                                                            readonly="readonly"
                                                        />
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th>Nilai Perilaku Kerja</th>
                                                    <td>
                                                        {/* {naskp} */}
                                                        {this.state.average}
                                                        
                                                    </td>
                                                    <td>X &nbsp; 40%</td>
                                                    <td>
                                                        <AvField
                                                            name="nilai_perilaku"
                                                            // placeholder="Target Biaya..."
                                                            type="number"
                                                            errorMessage="Masukkan Target Biaya"
                                                            className="form-control"
                                                            // validate={{ required: { value: true } }}
                                                            id="nilai perilaku"
                                                            value={(this.state.average!='' || !isNaN(this.state.average))? this.state.average*(40/100):0}
                                                            readonly="readonly"
                                                            style={{width:"80px"}}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={4}></td>
                                                    <td>
                                                    <AvField
                                                        name="skpsikap"
                                                        type="number"
                                                        id="nilai perilaku"
                                                        value={((this.state.average*40/100)+(naskp))}
                                                        readonly="readonly"
                                                        style={{width:"80px"}}
                                                    />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th colSpan={4}>Nilai Prestasi Kerja</th>
                                                    {/* <th>{this.state.nilai_prestasi }</th> */}
                                                    <th>
                                                        {
                                                            (((this.state.average*40/100)+(naskp))<50)?
                                                                 "Buruk":
                                                            
                                                            (((this.state.average*40/100)+(naskp))<60)?
                                                                 "Sedang":
                                                            (((this.state.average*40/100)+(naskp))<75)?
                                                                 "Cukup"
                                                            :
                                                            (((this.state.average*40/100)+(naskp))<90)?
                                                                 "Baik":
                                                            (((this.state.average*40/100)+(naskp))<99)?
                                                                 "Sangat Baik":'-'
                                                          
                                                        }
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                        
                                        <Row>
                                            <Col md="9">
                                                {/* <Link to={`/kepegawaian/skp.html?period_bawahan&euuid=${this.queryParams.get('euuid')}`}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link> */}
                                                {
                                                    (accessRole('approve'))?
                                                    <Link to={'/kepegawaian/skp.html?data&euuid='+this.queryParams.get('euuid')}>
                                                        <Button color="danger"><i className="uil-backspace"></i> Kembali</Button>&nbsp;&nbsp;
                                                    </Link>:
                                                    <Link to={'/kepegawaian/skp.html?period_bawahan&euuid='+this.queryParams.get('euuid')}>
                                                        <Button color="danger"><i className="uil-backspace"></i> Kembali</Button>&nbsp;&nbsp;
                                                    </Link>
                                                }
                                                {' '}
                                                {
                                                    (this.state.period.skp_period_status == 8 && this.state.currentmonth ==12)?
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                                :''
                                                }
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.message ?? "Data gagal disimpan"}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/skp.html?period_bawahan&euuid=${this.queryParams.get('euuid')}&perioduuid=${this.queryParams.get('perioduuid')}`}/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView